export interface IUdtMotion
{
    Version:number;
    DataLength:number;

    MovingState1:boolean;
    MovingState2:boolean;

    Executability1:boolean;
    Executability2:boolean;

    GroupError:boolean;
    NumberOfFinalPosition:number;
    
    FinalPosition:Array<boolean>;  //0..15

    Interlock1:boolean;
    Interlock2:boolean;

    ManualInterlock1:boolean;
    ManualInterlock2:boolean;

    ManualEnable1:boolean;
    ManualEnable2:boolean;

    ManualOperation1:boolean;
    ManualOperation2:boolean;

    DisplayOrder:Array<boolean>;  //0..15

    Trigger1:boolean;
    Trigger2:boolean;

    AutomaticTrigger1:boolean;
    AutomaticTrigger2:boolean;

    Control1:boolean;
    Control2:boolean;

    PositionFlag:Array<boolean>;  //0..15

    HmiId:number;
}

export class UdtMotion implements IUdtMotion
{
    Version:number = 0;
    DataLength:number = 0;

    MovingState1:boolean = false;
    MovingState2:boolean = false;

    Executability1:boolean = false;
    Executability2:boolean = false;

    GroupError:boolean = false;
    NumberOfFinalPosition:number = 0;
    
    FinalPosition:Array<boolean> = [];  //0..15

    Interlock1:boolean = false;
    Interlock2:boolean = false;

    ManualInterlock1:boolean = false;
    ManualInterlock2:boolean = false;

    ManualEnable1:boolean = false;
    ManualEnable2:boolean = false;

    ManualOperation1:boolean = false;
    ManualOperation2:boolean = false;

    DisplayOrder:Array<boolean> = [];  //0..15

    Trigger1:boolean = false;
    Trigger2:boolean = false;

    AutomaticTrigger1:boolean = false;
    AutomaticTrigger2:boolean = false;

    Control1:boolean = false;
    Control2:boolean = false;

    PositionFlag:Array<boolean> = [];  //0..15

    HmiId:number = 0;
}